import noteNames from '../constants/noteNames'
export * from './utilitiesBar'
export * from './utilitiesPresets'
export * from './utilitiesFetching'
export * from './utilitiesStorage'
export * from './utilitiesLearnMode'

export function formatClassNames(string) {
  return String(string)
    .split(",")
    .map((name) =>
      name
        .trim()
        .toLowerCase()
        .replace(/_+/g, "")
        .replace(/\s+/g, "-")
        .replace(/'+/g, "")
    )
    .join(" ");
}

export function midiNoteFormatter(value, noteOnly=false) {
  if(!value) return;
  if(isNaN(value) && value.includes('Select')) return;
  if(noteOnly) {
    return `${noteNames[value] ? noteNames[value] : ''}`
  }

	return isNaN(value) ? `${noteNames.indexOf(value)}       ${value}` : `${value}         ${noteNames[value]}`
}

export function isActive(value){
  return value > -1
}

export function isActiveClass(value){
  return isActive(value) ? 'active': null
}

export function inArray(set, index) {
	return set.includes(index)
}

export function itemIndex(set, item) {
	return set.indexOf(item)
}

/**
 * Converts LSB and MSB to 16-bit number
 * @function
 * @param {Number} bitArr - [LSB, MSB]
 * @returns {Number} 16-bit number from LSB and MSB
 */
export function convert8to16(bitArr){
	if(bitArr.every(val => val === -1)) return -1

	let lsb = bitArr[0], msb = bitArr[1]
	return ((msb << 8) + lsb);
}

/**
 * Converts 16-bit number to LSB and MSB.
 * @function
 * @param {Number} number - 16-bit number
 * @returns {Array} array of LSB and MSB; [LSB, MSB]
 */
export function convert16to8(number){
  if(number === -1) return [-1, -1]

	return [
  	number & 0xff,
		(number >> 8) & 0xff
  ]
}

/**
 * sets value to min / max if value is out of range
 * @function
 * @param {Object} DOM Element
 * @returns {Number}
 */
export function restrictNumberElement(element){
  let min = Number.isInteger(element.min) ? parseInt(element.min, 10) : parseFloat(element.min, 10),
      max = Number.isInteger(element.max) ? parseInt(element.max, 10) : parseFloat(element.max, 10),
      value = Number.isInteger(element.value) ? parseInt(element.value, 10) : parseFloat(element.value, 10)

  if(element.validity.valid) {
    return value
  } else if(value > max) {
    element.value = max
    return max
  } else if(value < min) {
    element.value = min
    return min
  }
}
export function restrictNumber(value,min,max) {
  const MIN = min || 0;
  const MAX = max || 1.00;
  const parsed = parseFloat(value);

  return Math.min(Math.max(parsed, MIN), MAX)
}

export function clip(value,min,max) {
  return Math.min(Math.max(value,min),max);
};

/**
 * Capitalizes string
 * @function
 * returns {String}
 */
export function capitalize(string) {
  return string.toLowerCase().replace( /\b\w/g, (m) => m.toUpperCase())
}

export const decimalCount = num => {
  // Convert to String
  const numStr = String(num);
  // String Contains Decimal
  if (numStr.includes('.')) {
     return numStr.split('.')[1].length;
  };
  // String Does Not Contain Decimal
  return 0;
}

export function pollPort(device, port, type, doesExist = true){
	console.log('>> malletStation: searching for', port, type, ', until', (doesExist) ? 'connected': 'disconnected')
	return new Promise((accept, reject) => {
		let foundPort,
        poll = window.setInterval(() => {
          foundPort = device._ports[`get${capitalize(type)}`](port, false)

  			if(foundPort) {
  				clearInterval(poll);
  				accept(foundPort)
  			}
  		}, 250)
	})
}

export function debugHelper() {
  const headingStyles = 'font-weight: bold;',
        messageStyles = 'border: 1px solid #fff6; border-radius: 0px; border-left: none; border-right: none; padding: 0 2px; background: #04aef033; color: white; font-family: monospace;';

  console.log(' ');
  console.log('__'.repeat(35));
  console.log(' Available Debug Flags (paste these into the console):');
  console.log(' %c* Sending / Receiving Messages', headingStyles);
  console.log(' - show the param and values that are being sent to the device:');
  console.log('   %cmalletStation._debug = true', messageStyles);
  console.log(' - show the OSC param and data response:');
  console.log('   %cmalletStation._oscDebug = true', messageStyles);
  console.log(' - show the raw OSC packet sent to the device:');
  console.log('   %cmalletStation._oscDebugSend = true', messageStyles);
  console.log(' %c* Learn Mode', headingStyles);
  console.log(' - show status messages from actions related to Learn Mode:');
  console.log('   %clearnLog = true', messageStyles);
  console.log(' - show all rawData coming from malletStation (bypassing debounce & crosstalk filters):');
  console.log('   %crawData = true', messageStyles);
  console.log(' - show data bypassing the debounce filter:');
  console.log('   %cshowDebounce = true', messageStyles);
  console.log(' - show data bypassing the crosstalk filter:');
  console.log('   %cshowCrosstalk = true', messageStyles);
  console.log(' %c* MIDI', headingStyles);
  console.log(' - show the MIDI data output from the device:');
  console.log('   %cshowMIDI = true', messageStyles);
  console.log('__'.repeat(35));
  console.log(' ');
}

export function isLinux(){
	if(typeof process !== "undefined" && process.platform === 'linux') {
		return true
	} else {
		return window.navigator &&
					 window.navigator.platform &&
					 window.navigator.platform.indexOf('Linux') >= 0
	}
}